import { useQuery } from "@tanstack/react-query";
import { supabaseClient } from "@/lib/supabase";
import type { EntryValueViewT } from "@patient-watch/types";

import { resolveBaselineEntryValueState, type BaselineEntryValueLookup } from "../utils/msAdlRatingsListHelpers";

interface TrackerEntryRow {
    entry_id: string;
    created_at: string | null;
    entry_values_view: EntryValueViewT[] | null;
}

export async function selectBaselineEntryValueByInputIdAndTrackerId(
    inputId: string,
    trackerId: string,
    currentEntryId?: string
): Promise<BaselineEntryValueLookup> {
    const { data: entries, error } = await supabaseClient
        .from("entries_view")
        .select("entry_id, created_at, entry_values_view(*)")
        .eq("tracker_id", trackerId)
        .order("created_at", { ascending: true });

    if (error) throw error;

    return resolveBaselineEntryValueState((entries ?? []) as TrackerEntryRow[], inputId, currentEntryId);
}

export const useBaselineEntryValueByInputIdAndTrackerId = (
    inputId: string | undefined,
    trackerId: string | undefined,
    currentEntryId?: string
) => {
    return useQuery({
        queryKey: ["baseline_entry_value", inputId, trackerId, currentEntryId],
        queryFn: () => selectBaselineEntryValueByInputIdAndTrackerId(inputId!, trackerId!, currentEntryId),
        enabled: Boolean(inputId && trackerId),
    });
};
